
import {isNil} from 'lodash'
import {developmentMatch, localMatch, productionMatch} from 'helpers/tracking/matches'

const productionId = '//js.hs-scripts.com/8757648.js'
const developmentId = '//js.hs-scripts.com/9372410.js'
export const hubspotDefaultTrackingId = developmentId

export const hubspotTrackingIds = [
  {
    match: productionMatch,
    id: productionId,
  },
  {
    match: developmentMatch,
    id: developmentId,
  },
  {
    match: localMatch,
    id: developmentId,
  },
]

export const trackPage = (path) => {
  const _hsq = window._hsq = window._hsq || []

  if (isNil(_hsq))
    return

  _hsq.push(['setPath', path])
  _hsq.push(['trackPageView'])
}
